import React from 'react';
import { Text } from '@atlaskit/primitives/compiled/text';
import { useIntl, defineMessage } from '@jira/platform__react-intl';

const hasErrorIndicator = defineMessage({
	id: 'accessible-workflow-diagram.common.validation-indicator.has-error-indicator',
	defaultMessage: 'Has error.',
	description: 'Indicates that a status or transition has an error',
});

const hasWarningIndicator = defineMessage({
	id: 'accessible-workflow-diagram.common.validation-indicator.has-warning-indicator',
	defaultMessage: 'Has warning.',
	description: 'Indicates that a status or transition has a warning',
});

const ValidationIndicator = ({
	validationFlag,
}: {
	validationFlag?: 'error' | 'warn';
}): React.JSX.Element | null => {
	const { formatMessage } = useIntl();
	if (!validationFlag) return null;

	return (
		<Text>
			{formatMessage(validationFlag === 'error' ? hasErrorIndicator : hasWarningIndicator)}
		</Text>
	);
};

export default ValidationIndicator;
